import React, { memo, useEffect } from "react";
import { useSnackbar } from "../../../hooks/useSnackbar";
import { AlertDialog } from "../../common/AlertDailog";
import { useProtocol } from "../../../hooks/useProtocol";
import Loader from "../../common/Loader/Loader";
import { hideLoader, showLoader } from "../../../store/slices/loaderSlice";
import { useAppDispatch } from "../../../store";

const DeleteProtocolDialog: React.FunctionComponent<any> = (props) => {
  const { showSuccess, handleError } = useSnackbar();
  const dispatch = useAppDispatch()
  const {
    openDeleteProtocol,
    setOpenDeleteProtocol,
    deleteDoc,
    setDeleteDoc,
    getAllProtocolFunc,
  } = props;
  const {
    deleteProtocol,
    deleteProtocolData,
    deleteProtocolIsError,
    deleteProtocolError,
    deleteProtocolIsSuccess,
    deleteProtocolsLoading
  } = useProtocol();

  const handleCloseDeleteProtocol = () => {
    setOpenDeleteProtocol(false);
  };
  const handleDeleteProtocol = () => {
    deleteProtocol({ protocol_uuid: deleteDoc?.id });
  };
  useEffect(() => {
    if (deleteProtocolIsSuccess) {
      const successMsg = deleteProtocolData;
      getAllProtocolFunc();
      showSuccess(successMsg?.details,'protocol-delete-success');
      setDeleteDoc({});
      dispatch(hideLoader())
      handleCloseDeleteProtocol();
    }
  }, [deleteProtocolIsSuccess]);
  useEffect(() => {
    if (deleteProtocolIsError) {
      const errorMsg: any = deleteProtocolError;
      handleError(errorMsg);
      dispatch(hideLoader())
    }
  }, [deleteProtocolIsError]);

  useEffect(()=>{
    if(deleteProtocolsLoading){
      dispatch(showLoader())
    }else{
      dispatch(hideLoader())
    }
  },[deleteProtocolsLoading])
  return (
    <>
      <Loader/>
      <AlertDialog
        open={openDeleteProtocol}
        title="Delete Protocol"
        description={`Are you sure you want to delete the protocol <strong>${deleteDoc?.protocol_name}</strong>?`}
        handleClose={handleCloseDeleteProtocol}
        handleConfirm={handleDeleteProtocol}
        confirmBtn="Yes"
        cancelBtn="No"
        maxWidth="xs"
      />
    </>
  );
};

export default memo(DeleteProtocolDialog);
